"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionLine = void 0;
const React = require("react");
const List_1 = require("../../../../../../components/base/structure/List");
const Currency_1 = require("../../../../../../components/base/atoms/Currency");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "PromotionLine");
const PromotionLine = ({ promotion }) => {
    return (React.createElement(List_1.ListItemWrapper, { className: css("") },
        React.createElement(List_1.ListItemBody, null,
            React.createElement(PromotionItem, { promotion: promotion }))));
};
exports.PromotionLine = PromotionLine;
/**
 * Displays a highlighted applied promotion in a cart summary showing both the description and discount
 * deducted.
 */
const PromotionItem = ({ promotion }) => {
    return (React.createElement("div", { className: css("promotionItem") },
        React.createElement("div", { className: "promotionItem_description" }, promotion.description),
        React.createElement("label", { className: "promotionItem_discount" },
            "-",
            React.createElement(Currency_1.Currency, null, promotion.priceDiscounted))));
};
//# sourceMappingURL=index.js.map